module.exports = __webpack_public_path__ + "static/media/sub_meal04.c3a87c6a.png";